import { useDispatch } from 'react-redux';
import { CustomAlert } from '../../../shared/uiComponents';
import { DispatchProperties, useSelector } from '../../../redux/store';
import { setEditDiscretionary } from '../../../redux/State/clientSlice/calendarHelperSlice';
import AdminHoursForm from './adminHoursForm';

const EditDiscretionaryHours = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const open = useSelector((state) => state.calendarHelper.popups.editDiscretionary);
	const existing = useSelector((state) => state.calendarHelper.infoDiscretionaryData);
	const close = () => dispatch(setEditDiscretionary(false));

	return (
		<CustomAlert
			open={open}
			onClose={close}
			titleOnTop={false}
			title="Edit Admin Hours"
			Content={() => (existing ? <AdminHoursForm existing={existing} onClose={close} /> : null)}
		/>
	);
};

export default EditDiscretionaryHours;
